import { Form } from 'antd';
import BodyAdjustItem from './BodyAdjustItem';

import cx from './index.module.scss';

interface Props {
  bodyAdjustListProblems: AIDiagnoseSubmitParams['bodyAdjustList'];
  handleDelete: (value: Diagnose, therapyType: AIDiagnose.TherapyType) => void;
}

const BodyAdjust: React.FC<Props> = ({ bodyAdjustListProblems, handleDelete }) => {
  return (
    <div className={cx('wrapper')}>
      <div className={cx('header')}>
        <div>体态调整</div>
        <div onClick={() => handleDelete('bodyAdjustList', 'bodyAdjust')}>删除</div>
      </div>

      <div className={cx('content')}>
        <Form.List name="bodyAdjustList">
          {fields =>
            fields.map(({ key, name }) => (
              <div key={bodyAdjustListProblems?.[name]?.problem}>
                <Form.Item noStyle name={[name, 'problem']} />
                <Form.Item noStyle name={[name, 'level']}>
                  <BodyAdjustItem name={bodyAdjustListProblems?.[name]?.problem} />
                </Form.Item>
              </div>
            ))
          }
        </Form.List>
      </div>
    </div>
  );
};

export default BodyAdjust;
